import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularUnstakeTransaction: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_unstake-transaction"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="unstake-transaction icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M16.1885 4.51912L5.1287 15.5905H7.70635C8.00259 15.5905 8.24274 15.8306 8.24274 16.1269C8.24274 16.4231 8.00259 16.6633 7.70635 16.6633H3.33268V12.2496C3.33268 11.9533 3.57283 11.7132 3.86907 11.7132C4.16531 11.7132 4.40546 11.9533 4.40546 12.2496V14.7954L15.4301 3.75926C15.6395 3.54958 15.979 3.54958 16.1885 3.75926C16.3981 3.96906 16.3981 4.30932 16.1885 4.51912Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9792 13.8175C10.9792 12.2451 12.2525 10.9709 13.8226 10.9709C15.3928 10.9709 16.666 12.2451 16.666 13.8175C16.666 15.3898 15.3928 16.6641 13.8226 16.6641C12.2525 16.6641 10.9792 15.3898 10.9792 13.8175ZM13.8226 12.0437C12.8461 12.0437 12.052 12.8365 12.052 13.8175C12.052 14.7984 12.8461 15.5913 13.8226 15.5913C14.7992 15.5913 15.5932 14.7984 15.5932 13.8175C15.5932 12.8365 14.7992 12.0437 13.8226 12.0437Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.3327 6.16204C3.3327 4.59813 4.59911 3.33073 6.16081 3.33073C7.72251 3.33073 8.98892 4.59813 8.98892 6.16204C8.98892 7.72595 7.72251 8.99334 6.16081 8.99334C4.59911 8.99334 3.3327 7.72595 3.3327 6.16204ZM6.16081 4.40353C5.1927 4.40353 4.40548 5.18951 4.40548 6.16204C4.40548 7.13457 5.1927 7.92055 6.16081 7.92055C7.12892 7.92055 7.91614 7.13457 7.91614 6.16204C7.91614 5.18951 7.12892 4.40353 6.16081 4.40353Z"
        />
      </svg>
    </span>
  );
};

export { RegularUnstakeTransaction };
